module.exports = __webpack_public_path__ + "static/flowers.1b59a055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/flowers.svg
// module id = 136
// module chunks = 34178662049645 118501925879540